// extracted by mini-css-extract-plugin
export default {"table":"UsersListWeb_table__TDnQD","center":"UsersListWeb_center__kbqsb","right":"UsersListWeb_right__oMz+u"};